import { RadioGroupAPI } from '@philips-internal/oswald-ui-components';

export enum ScoresAndIndexesStatusType {
  ACTIVE  = 'A',
  PENDING = 'P'
}

export interface DomainType {
  description: string;
  situation: string;
  valueDomain: string;
}

export interface PersonType {
  bornDate: string;
  personCode: string;
  personName: string;
}

export interface SearchType {
  description: string;
  id: number;
}

export interface StringType {
  description: string;
  id: string;
}

export interface ScoreMorseResponse {
  dateEvaluation?: string;
  diaSecondary?: string;
  helpDeambular?: number;
  heparin?: string;
  histFall?: string;
  idScoreIndexes?: number;
  mentalState?: number;
  professional?: StringType;
  punctuation?: SearchType;
  showInactivate?: boolean;
  walkingMode?: number;
}

export interface ScoreDINIResponse {
  activity?: DomainType;
  bodyHygiene?: DomainType;
  dateEvaluation?: string;
  drugTherapy?: DomainType;
  eliminations?: DomainType;
  foodAndHydration?: DomainType;
  idScoreIndexes?: number;
  intervControles?: DomainType;
  mobility?: DomainType;
  mucosalCutaneousIntegrity?: DomainType;
  networkSupport?: DomainType;
  oxygenation?: DomainType;
  partCompanion?: DomainType;
  professionalCode?: string;
  professionalName?: string;
  qtPunctuation?: number;
  result?: string;
  resultDesc?: string;
  showInactivate?: boolean;
}

export interface ScoreNASResponse {
  descriptionItem10?: string;
  descriptionItem11?: string;
  descriptionItem12?: string;
  descriptionItem13?: string;
  descriptionItem14?: string;
  descriptionItem15?: string;
  descriptionItem16?: string;
  descriptionItem17?: string;
  descriptionItem18?: string;
  descriptionItem19?: string;
  descriptionItem1a?: string;
  descriptionItem1b?: string;
  descriptionItem1c?: string;
  descriptionItem2?: string;
  descriptionItem20?: string;
  descriptionItem21?: string;
  descriptionItem22?: string;
  descriptionItem3?: string;
  descriptionItem4a?: string;
  descriptionItem4b?: string;
  descriptionItem4c?: string;
  descriptionItem5?: string;
  descriptionItem6a?: string;
  descriptionItem6b?: string;
  descriptionItem6c?: string;
  descriptionItem7a?: string;
  descriptionItem7b?: string;
  descriptionItem8a?: string;
  descriptionItem8b?: string;
  descriptionItem8c?: string;
  descriptionItem9?: string;
  dtEvaluation: string;
  hour?: DomainType;
  idScoreIndexes?: number;
  professionalCode?: string;
  professionalName?: string;
  result?: string;
  resultDesc?: string;
  showInactivate?: boolean;
}

export interface ScoreNRSResponse {
  age: string;
  diseaseSeverityDomain: DomainType;
  evaluationDate: string;
  height: string;
  imc: string;
  note: string;
  nutritionalStatusDomain: DomainType;
  professionalCode: string;
  professionalName: string;
  punctuation: string;
  reducedFeeding: string;
  resultNrs: string;
  showInactivate?: boolean;
  usualWeight: string;
  uti: string;
  weight: string;
  weightLoss: string;
  weightLossLastMonth: string;
}

export interface ScorePEWSResponse {
  cardiovascular?: DomainType;
  dateEvaluation?: string;
  idScoreIndexes?: number;
  nebulization?: string;
  neurologicalStatus?: DomainType;
  professionalCode?: string;
  professionalName?: string;
  respiratory?: DomainType;
  result?: string;
  scoreQuantity?: number;
  showInactivate?: boolean;
  vomit?: string;
}

export interface ScoreMEWSResponse {
  consciousnessLevel?: DomainType;
  dateEvaluation?: string;
  freqCardiaca?: number;
  freqRespiratoria?: number;
  idScoreIndexes?: number;
  paSistolica?: number;
  professionalCode?: string;
  professionalName?: string;
  result?: string;
  scoreQuantity?: number;
  showInactivate?: boolean;
  temperatura?: number;
}

interface TimeType {
  description?: string;
  valueDomain?: string;
}

export interface ScoreTISS28Response {
  acidoseAlcalose?: string;
  cateterArtPerif?: string;
  curativoFrequente?: string;
  curativoRotina?: string;
  diureseAtiva?: string;
  dreno?: string;
  evaluationDate?: string;
  idScoreIndexes?: number;
  interForaUti?: string;
  interMultiUti?: string;
  interUnicaUti?: string;
  laboratorio?: string;
  medDebitoUrina?: string;
  medicEndovenosa?: string;
  medicaUnica?: string;
  monitPadrao?: string;
  nutEnteral?: string;
  nutParent?: string;
  pressaoIntracraniana?: string;
  professionalCode?: string;
  professionalName?: string;
  repVolemica?: string;
  ressuscitCardio?: string;
  result?: string;
  scMonitAtrioEsquerdo?: string;
  scoreQuantity?: number;
  showInactivate?: boolean;
  suepVentSupl?: string;
  tecHemofiltracao?: string;
  time?: TimeType;
  tratFuncaoPulmonar?: string;
  vasoativaMulti?: string;
  vasoativaUnica?: string;
  ventMecanica?: string;
  viaVenosaCentral?: string;
  viasAerias?: string;
}

export interface ScoreTISS28Request {
  acidoseAlcalose: boolean;
  cateterArtPerif: boolean;
  curativoFrequente: boolean;
  curativoRotina: boolean;
  diureseAtiva: boolean;
  dreno: boolean;
  evaluationDate: string;
  idScoreIndexes?: number;
  interForaUti: boolean;
  interMultiUti: boolean;
  interUnicaUti: boolean;
  laboratorio: boolean;
  medDebitoUrina: boolean;
  medicEndovenosa: boolean;
  medicaUnica: boolean;
  monitPadrao: boolean;
  nutEnteral: boolean;
  nutParent: boolean;
  pressaoIntracraniana: boolean;
  professionalName:string;
  punctuation: string;
  repVolemica: boolean;
  ressuscitCardio: boolean;
  result: string;
  scMonitAtrioEsquerdo: boolean;
  suepVentSupl: boolean;
  tecHemofiltracao: boolean;
  time?: string;
  tratFuncaoPulmonar: boolean;
  vasoativaMulti: boolean;
  vasoativaUnica: boolean;
  ventMecanica: boolean;
  viaVenosaCentral: boolean;
  viasAerias: boolean;
}

export interface ScoreIndexesVisualization {
  cdPerfil: number;
  cdPessoaFisica: string | number;
}

export interface RadioGroupData {
  field: RadioGroupAPI
  props: string
}

export interface ResponseCreateScoreDINI {
  activity?: number;
  attendance?: number;
  bodyHygiene?: number;
  drugTherapy?: number;
  eliminations?: number;
  evaluationDate?: string;
  foodAndHydration?: number;
  idScoreIndexes: number;
  intervControles?: number;
  levelAttention?: string;
  mobility?: number;
  mucosalCutaneousIntegrity?: number;
  networkSupport?: number;
  oxygenation?: number;
  partCompanion?: number;
  professional?: string;
  qtPunctuation?: number;
  time?: number;
  updateDate?: string;
  updateNrec?: string;
  username?: string;
  usuarioNREC?: string;
}

export interface ResponseCreateScoreMEWS {
  attendance?: number;
  consciousnessLevel?: string;
  evaluationDate?: string;
  idScoreIndexes: number;
  levelAttention?: string;
  professionalCode?: string;
  scoreQuantity?: number;
  situation?: string;
  temperatura?: number;
  time?: number;
  updateDate?: string;
  updateNrec?: string;
  username?: string;
  usuarioNREC?: string;
}

export interface ResponseCreateScorePEWS {
  attendance?: number;
  cardiovascular?: number;
  evaluationDate?: string;
  idScoreIndexes: number;
  levelAttention?: string;
  nebulization?: string;
  neurologicalStatus?: number;
  professionalCode?: string;
  respiratory?: number;
  scoreQuantity?: number;
  situation?: string;
  updateDate?: string;
  updateNrec?: string;
  username?: string;
  usuarioNREC?: string;
  vomit?: string;
}
